import { FunctionalElement } from './functional-element';

export type FunctionalElements = Readonly<{
    [key: number]: FunctionalElement;
}>;

export const initialFunctionalElements = {};
